import { render } from "./hospedaje.vue?vue&type=template&id=581b4c3a&scoped=true"
import script from "./hospedaje.vue?vue&type=script&lang=js"
export * from "./hospedaje.vue?vue&type=script&lang=js"

import "./hospedaje.vue?vue&type=style&index=0&id=581b4c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581b4c3a"]])

export default __exports__